/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_PhotosInputs */

const en_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Photos`)
};

const es_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos premium`)
};

const fr_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos Premium`)
};

const de_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-Fotos`)
};

const ja_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレミアム写真`)
};

const zh_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高清照片`)
};

const ar_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صور عالية الجودة`)
};

const id_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto Premium`)
};

const it_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto Premium`)
};

const ru_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум фото`)
};

const pt_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos Premium`)
};

const ko_premium_photos = /** @type {(inputs: Premium_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄 사진`)
};

/**
* | output |
* | --- |
* | "Premium Photos" |
*
* @param {Premium_PhotosInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const premium_photos = /** @type {((inputs?: Premium_PhotosInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_PhotosInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_premium_photos(inputs)
	if (locale === "es") return es_premium_photos(inputs)
	if (locale === "fr") return fr_premium_photos(inputs)
	if (locale === "de") return de_premium_photos(inputs)
	if (locale === "ja") return ja_premium_photos(inputs)
	if (locale === "zh") return zh_premium_photos(inputs)
	if (locale === "ar") return ar_premium_photos(inputs)
	if (locale === "id") return id_premium_photos(inputs)
	if (locale === "it") return it_premium_photos(inputs)
	if (locale === "ru") return ru_premium_photos(inputs)
	if (locale === "pt") return pt_premium_photos(inputs)
	return ko_premium_photos(inputs)
});